import React from 'react';
import PropTypes from 'prop-types';
import {
  CollectionHeadline,
  Rga,
  TranslationProvider,
  containerQueryProps,
} from '@resy/ui-kitchen';
import EventList from '../EventList';

import './EventsByLocation.scss';

const EventsByLocation = (
  {
    containerQuery,
    events,
    gdaEvents,
    homepageModule,
    locationSlug,
  }
) => {
  const totalEvents = events?.metadata?.total || 0;
  const totalGdaEvents = gdaEvents?.metadata?.total || 0;
  const maxGdaEventCards = 10;
  const maxEventCards = homepageModule ? 12 : totalEvents;

  if (homepageModule && events && totalEvents === 0) {
    return null;
  }

  const loading = !(events);

  return (
    <div className="EventsByLocation container">
      {!homepageModule
        && (
          <>
            <div className="EventsByLocation__title-container">
              <div className="EventsByLocation__title-headline container">
                <CollectionHeadline
                  badge="https://s3.amazonaws.com/resy.com/images/lists/events.svg"
                  title="Special Events &amp; Experiences"
                  translationKey="special_events"
                />
              </div>
            </div>
            {gdaEvents && totalGdaEvents > 0
              && (
                <>
                  <div className="EventsByLocation__title-container">
                    <div className="container">
                      <Rga variant="heading" />
                    </div>
                  </div>
                  <EventList
                    locationSlug={locationSlug}
                    events={gdaEvents?.results?.events}
                    totalEvents={totalGdaEvents}
                    maxCards={maxGdaEventCards}
                    homepageModule={homepageModule}
                    loading={loading}
                    isGda
                    containerQuery={containerQuery}
                  />
                  <div className="EventsByLocation__title-container">
                    <div className="container">
                      <TranslationProvider translationKey="more_upcoming_events">
                        <h2 className="EventsByLocation__more-upcoming">More Upcoming</h2>
                      </TranslationProvider>
                    </div>
                  </div>
                </>
              )}
          </>
        )}
      <EventList
        locationSlug={locationSlug}
        events={events?.results?.events}
        totalEvents={totalEvents}
        maxCards={maxEventCards}
        homepageModule={homepageModule}
        loading={loading}
        containerQuery={containerQuery}
      />
    </div>
  );
};

const eventsByLocationPropsTypes = {
  Analytics: PropTypes.shape({
    event: PropTypes.func.isRequired,
  }).isRequired,
  containerQuery: containerQueryProps,
  events: PropTypes.shape({
    metadata: PropTypes.shape({
      total: PropTypes.number,
    }),
    results: PropTypes.shape({
      events: PropTypes.arrayOf(PropTypes.object),
    }),
  }),
  gdaEvents: PropTypes.shape({
    metadata: PropTypes.shape({
      total: PropTypes.number,
    }),
    results: PropTypes.shape({
      events: PropTypes.arrayOf(PropTypes.object),
    }),
  }),
  homepageModule: PropTypes.bool,
  locationSlug: PropTypes.string,
};

EventsByLocation.defaultProps = {
  containerQuery: {},
  events: null,
  gdaEvents: null,
  homepageModule: false,
  locationSlug: 'new-york-ny',
};

EventsByLocation.propTypes = eventsByLocationPropsTypes;
EventsByLocation.displayName = 'EventsByLocation';

export { eventsByLocationPropsTypes };
export default EventsByLocation;
